import React, { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import * as yup from 'yup'

import { vaccineTypeOptions, VaccineTypeValue } from 'src/constants/vaccineType'
import { createVaccine, updateVaccine, VaccineProps } from 'src/store/ducks/vaccine'

import { Button, Divider, Input, SelectInput } from 'src/components'
import { useStyles } from './styles'

const schema = yup.object().shape({
  data: yup.object().shape({
    descricao: yup.string().required('Descrição é obrigatório'),
    dose: yup.string().required('Dose é obrigatório'),
    tipo: yup.string().required('Tipo é obrigatório'),
  })
})

interface UpdateVaccineProps {
  value: VaccineProps
  onClose: React.MouseEventHandler | any
}

const UpdateVaccine: React.FC<UpdateVaccineProps> = ({ value, onClose }) => {
  const dispatch = useDispatch()
  const style = useStyles()

  const {
    setValue,
    handleSubmit,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm<any>({ resolver: yupResolver(schema) })

  const onFocus = () => {
    const input = document.getElementById('updateVaccine')
    input?.focus()
  }

  const onSubmit = handleSubmit((data) => {
    const defaultValue = {
      idVacina: data.idVacina
    }
    data.idVacina ?
      dispatch(updateVaccine({ ...data, ...defaultValue })) :
      dispatch(createVaccine({ ...data, ...defaultValue }))
    onClose()
  })

  useEffect(() => {
    setValue('data.descricao', value?.data?.descricao)
    setValue('data.dose', value?.data?.dose)
    setValue('data.tipo', value?.data?.tipo)
    setValue('data.idVacina', value?.idVacina)
    onFocus()
  }, [])

  return (
    <>
      <div className={style.updateVaccineContainer}>
        <Input
          label='Descrição'
          id='updateVaccine'
          value={watch('data.descricao')}
          className={style.updateVaccineInput}
          placeholder='Descrição'
          error={errors?.data?.descricao?.message}
          onChange={(value: string) => {
            setValue('data.descricao', value)
            clearErrors('data.descricao')
          }}
        />
        <Input
          label='Dose'
          value={watch('data.dose')}
          placeholder='Dose'
          error={errors?.data?.dose?.message}
          className={style.updateVaccineInput}
          onChange={(value: string) => {
            setValue('data.dose', value)
            clearErrors('data.dose')
          }}
        />
        <SelectInput
          label='Tipo'
          selectBy='id'
          showBy={['value']}
          options={vaccineTypeOptions}
          placeholder='Selecionar Tipo'
          value={watch('data.tipo') || ''}
          className={style.updateVaccineInput}
          error={errors?.data?.tipo?.message}
          onChange={(item: VaccineTypeValue) => {
            setValue('data.tipo', item.id)
            clearErrors('data.tipo')
          }}
        />
        <Divider />
        <div className={style.updateVaccineButtonContainer}>
          <Button className={style.updateVaccineButtonCancel} onClick={onClose}>
            Cancelar
          </Button>
          <Button className={style.updateVaccineButton} onClick={onSubmit}>
            Salvar
          </Button>
        </div>
      </div>
    </>
  )
}

export default UpdateVaccine
